module.exports = __webpack_public_path__ + "img/19.492249c8.jpg";